/* eslint-disable react/jsx-max-props-per-line */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import validate from 'validate.js';
import { Grid } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import {
  DialogDefaultV2,
  NumberInputV2,
  OptionSelectV2,
} from '../../../../../components/v2';

const materialSchema = {
  tipo: { presence: { allowEmpty: false, message: 'é obrigatório' } },
  pesoKg: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
    numericality: { greaterThan: 0, message: 'deve ser maior que zero' },
  },
};

const SucataMaterialDialog = ({
  open,
  item,
  onClose,
  onSave,
}) => {
  const [values, setValues] = useState({ tipo: '', tipoNome: '', pesoKg: null });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (open) {
      setValues(item || { tipo: '', tipoNome: '', pesoKg: null });
      setErrors({});
    }
  }, [open, item]);

  const handleSave = () => {
    const validationErrors = validate(values, materialSchema);
    setErrors(validationErrors || {});
    if (validationErrors) return;

    onSave({
      ...values,
      id: values.id || uuidv4(),
      pesoKg: Number(values.pesoKg),
    });
    onClose();
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={onClose}
      handlerConfirm={handleSave}
      title="Adicionar material"
      confirmMessage="Salvar"
      maxWidth="sm"
      fullWidth
    >
      <Grid container spacing={1} sx={{ pt: 1 }}>
        <Grid size={{ xs: 12 }}>
          <OptionSelectV2
            label="Material de Sucata"
            codigo="USO_MUTUO_TIPO_SUCATA"
            isRequired
            value={values.tipo}
            error={!!(errors && errors.tipo)}
            onSelect={(tipo, tipoNome) => setValues((prev) => ({ ...prev, tipo, tipoNome }))}
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <NumberInputV2
            label="Peso (kg)"
            name="pesoKg"
            isRequired
            prefix=""
            decimalScale={2}
            fixedDecimalScale
            decimalSeparator=","
            thousandSeparator="."
            value={values.pesoKg}
            error={!!(errors && errors.pesoKg)}
            onChange={(pesoKg) => setValues((prev) => ({ ...prev, pesoKg }))}
          />
        </Grid>
      </Grid>
    </DialogDefaultV2>
  );
};

SucataMaterialDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  item: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

SucataMaterialDialog.defaultProps = {
  item: null,
};

export default SucataMaterialDialog;
